export default partNumber => `/product/${partNumber}`
